<div class="download-item" [nbSpinner]="loading()" nbSpinnerStatus="primary">
  <nb-icon icon="file-text-outline" pack="eva"></nb-icon>

  <div class="download-text">
    <b>{{ label() }}</b>

    @let activePdf = inspectionPdf();

    @if (activePdf) {
      <span>Zuletzt geändert: {{ activePdf.lastGenerated | date: 'dd.MM.yyyy HH:mm' }}
          <nb-icon
            icon="info-outline"
            pack="eva"
            class="info-icon"
            [nbTooltip]="getTooltipContent(activePdf)">
          </nb-icon>
      </span>
      @if (activePdf.excludeFinishedRepairTasks) {
        <span class="filter-hint" data-cy="excludes-finished-repair-tasks-hint">ohne abgeschlossene Reparaturaufträge</span>
      }
      @if (activePdf.inspectionVersion !== inspection().version) {
        <span class="warning">(veraltet)</span>
      }
    } @else {
      <span>Nicht vorhanden</span>
    }
  </div>

  @if (inspectionPdfType() === InspectionPdfTypeEnum.Shortlist && canEdit()) {
    <form [formGroup]="filter" class="shortlist-filter">
      <wr-inspection-contractor-select id="contractorId" formControlName="contractorId" [showEmptyOption]="true">
      </wr-inspection-contractor-select>
      <div class="filter-option"
           data-cy="exclude-finished-repair-tasks-option"
           nbTooltip="Abgeschlossene Reparaturaufträge exkludieren: Prüfpunktzeilen mit abgeschlossenem Reparaturauftrag kommen nicht in die Shortlist">
        <nb-checkbox formControlName="excludeFinishedRepairTasks" data-cy="exclude-finished-repair-tasks">
          Ohne erledigte Aufträge
        </nb-checkbox>
      </div>
    </form>
  }

  @if (canEdit()) {
    <form [formGroup]="filter">
      <wr-building-section-multi-select
        id="buildingSections"
        formControlName="buildingSections"
        [buildingId]="inspection().building.id">
      </wr-building-section-multi-select>
    </form>
  }

  <nb-button-group class="download-buttons">
    @if (activePdf) {
      @if (canEdit()) {
        <button (click)="generatePdf()"
                nbButton
                status="basic"
                [disabled]="loading()"
                nbTooltip="Neu generieren">
          <nb-icon pack="eva" icon="refresh-outline"></nb-icon>
        </button>
      }

      <button (click)="downloadPdf()"
              nbButton
              status="basic"
              [disabled]="loading()"
              [nbTooltip]="label() + ' herunterladen'">
        <nb-icon pack="eva" icon="download-outline"></nb-icon>
      </button>

      @if (supportsInlineView()) {
        <button (click)="openPdfLink()"
                nbButton
                status="basic"
                [disabled]="loading()"
                [nbTooltip]="label() + ' öffnen'">
          <nb-icon pack="eva" icon="external-link-outline"></nb-icon>
        </button>

        @if (canEdit()) {
          <button (click)="openPdfShareLink()"
                  nbButton
                  status="basic"
                  [disabled]="loading()"
                  [nbTooltip]="label() + ' teilen'">
            <nb-icon pack="eva" icon="share-outline"></nb-icon>
          </button>
        }
      }

      @if (canEdit()) {
        <button (click)="deletePdf()"
                nbButton
                status="basic"
                [disabled]="loading()"
                [nbTooltip]="label() + ' löschen'">
          <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
        </button>
      }
    } @else {
      @if (canEdit()) {
        <button (click)="generatePdf()"
                nbButton
                status="basic"
                [disabled]="loading()"
                nbTooltip="Generieren">GENERIEREN
        </button>
      } @else {
        <div>Nicht generiert!</div>
      }
    }
  </nb-button-group>
</div>
